/**
 * Signed-in `/`. Keep ?website=&company= on Home so admins can preview a
 * client's onboarding widget. Signed-out legacy report links still redirect
 * in HomeEntry.
 */
import React, { lazy, Suspense } from 'react';

const HomePage = lazy(() => import('./pages/HomePage.jsx'));

export default function IndexEntry() {
  return (
    <Suspense fallback={<div className="loading-spinner-container"><div className="loading-spinner" /></div>}>
      <HomePage />
    </Suspense>
  );
}
